import React, { useMemo } from 'react'
import { FenToYuan } from '~/utils'
import styled from 'styled-components'
import { useOrder } from '../order/hooks'
const StyledContent = styled.div<{ isDarkMode: boolean }>`
  .priceBox {
    background-color: ${props =>
      props.isDarkMode ? props.theme.dark1 : '#fff'};
    color: ${props => (props.isDarkMode ? '#B1B5C3' : props.theme.dark1)};
    border-color: ${props =>
      props.isDarkMode ? props.theme.dark3 : props.theme.divider1};
  }
  .price {
    color: ${props => (props.isDarkMode ? '#B1B5C3' : props.theme.dark1)};
  }
`
export const ProductPrice: React.FC<{
  orderData: any
  isDarkMode?: boolean
}> = ({ orderData, isDarkMode = false }) => {
  const { deliveryFee: _deliveryFee, totalFeeList: _totalFeeList } = useOrder()
  //运费
  const deliveryFee = useMemo(() => {
    return _deliveryFee(orderData?.feeRecordList)
  }, [orderData, _deliveryFee])
  //优惠项目
  const totalFeeList = useMemo(() => {
    return _totalFeeList(orderData?.feeRecordList)
  }, [orderData, _totalFeeList])
  return (
    <StyledContent isDarkMode={isDarkMode} className="mb-6">
      <div className="border-rounded priceBox">
        <div className="text-sm text-neutral-400 font-normal mb-2">
          商品金额
          <span className="text-neutral-200 float-right price">
            ¥ {FenToYuan(orderData?.totalFee - deliveryFee)}
          </span>
        </div>
        {totalFeeList?.length
          ? totalFeeList?.map((it: any, index: number) => {
              return it?.fee > 0 ? (
                <div
                  className="text-sm text-neutral-400 font-normal mb-2"
                  key={index}
                >
                  {it?.name}
                  <span className="text-neutral-200 float-right">
                    -¥ {FenToYuan(it?.fee)}
                  </span>
                </div>
              ) : (
                <div
                  className="text-sm text-neutral-400 font-normal mb-2"
                  key={index}
                >
                  {it?.name}
                  <span className="text-neutral-200 float-right">
                    ¥ {FenToYuan(-it?.fee)}
                  </span>
                </div>
              )
            })
          : null}
        <div className="text-sm text-neutral-400 font-normal">
          合计
          <span className="text-error float-right">
            ¥ {FenToYuan(orderData?.realFee)}
          </span>
        </div>
      </div>
    </StyledContent>
  )
}
